import React, { useState, useEffect } from 'react';
import useTable from "../../useTable"
import { ActualizarEstadoVehiculos } from './modalActualizarEstadoVehiculos';
import axios from 'axios';
import { Dimmer } from '../../spinner';
import { SearchInput } from '../../../ui/inputs/Input';

const headCells = [
    { id: 'placa', label: 'PLACA', width: '20px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', color: "white" },
    { id: 'ritm', label: 'RITM', width: '20px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', color: "white" },
    { id: 'nombrepropie', label: 'NOMBRE', width: '200px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', color: "white" },
    { id: 'idvehiculo', label: 'CÓDIGO', width: '20px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', color: "white" },
    { id: 'accion', label: 'OPCIONES', width: '60px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', color: "white" },
]
function TablaEstadoVehiculos(props) {
    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [mostrar, setMostrar] = useState(false);
    const [mostrar5, setMostrar5] = useState(false);
    const [activate, setActivate] = useState(false);
    const [factorCambio, setFactorCambio] = useState(0)
    const [operacion, setOperacion] = useState(0);
    const [deuda, setDeuda] = useState();
    const [historico, setHistorico] = useState();
    const [espiritu] = useState(localStorage.getItem('espiritu'));
    const [fechaSistema] = useState(localStorage.getItem('fechasistema'));
    const [vehiculo, setVehiculo] = useState();
    const [multas, setMultas] = useState();
    const [records, setRecords] = useState([]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })
    let token = localStorage.getItem('jwtToken');
    let op = require('../../../../src/modulos/datos');
    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTable(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (x.idvehiculo.includes(target.value)
                            || x.placa.toLowerCase().includes(target.value.toLowerCase())
                            || x.ritm.toLowerCase().includes(target.value.toLowerCase())
                            || x.nombrepropie.toLowerCase().includes(target.value.toLowerCase())
                            || x.idvehiculo.includes(target.value)) {
                            return x;
                        }
                    });
                }
            }
        })
    }
    const blanquear = () => {
        setMostrar(false);
        setTitulo('');
        setMsg('');
        setActivate(false);
        setVehiculo();
    }
    const seleccionarRegistros = () => {
        let campos = 'placa, ritm, TRIM(nombrepropie) AS nombrepropie, idvehiculo';
        let nomtab = 'vehiculo';
        let orden = 'idvehiculo';
        let endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
        setActivate(true);
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'
            },
        }).then(function (response) {
            if (response.status == 200) {
                setRecords(response.data);
                setActivate(false);
            }
        }).catch(function (error) {
            setTitulo("ERROR");
            setMsg(error.response.data.message)
            setMostrar(true)
            setActivate(false);
        })
    }

    const seleccionarFactorCambio = () => {
        let endpoint = `${op.conexion}/api/vehiculo/factorcambio`;
        setActivate(true);
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'
            },
        }).then(function (response) {
            if (response.status == 200) {
                setFactorCambio(response.data.valor)
            }
        }).catch(function (error) {
            setTitulo("ERROR");
            setMsg(error.response.data.message)
            setMostrar5(true)
            setActivate(false);
        })
    }

    const SelectDeudaVehiculo = (idvehiculo) => {
        let endpoint = `${op.conexion}/api/vehiculo/deudavehiculo?idvehiculo=${idvehiculo}&fecha=${fechaSistema}&espiritu=${espiritu}`;
        setActivate(true);
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'
            },
        }).then(function (response) {
            var deu = [];
            var his = [];
            for (let i = 0; i < response.data.length; i++) {
                if (response.data[i].fechapago === null) {
                    deu.push({
                        anio: response.data[i].anio, mes: response.data[i].mes.replace("'", "").replace("'", ""),
                        monto: response.data[i].mondeu,
                        intereses: response.data[i].intmoradeu,
                        recargo: response.data[i].recargodeu,
                        descuento: response.data[i].mondescue,
                        totalperi: response.data[i].subtotal, status: response.data[i].estatus,
                        idfac: response.data[i].idfact, nummes: response.data[i].nmes,
                        estatusfac: response.data[i].estatusfac, tipotransaccion: response.data[i].tipotransaccion
                    });
                } else {
                    his.push({
                        anio: response.data[i].anio, mes: response.data[i].mes.replace("'", "").replace("'", ""),
                        monto: response.data[i].mondeu, intereses: response.data[i].intmoradeu,
                        recargo: response.data[i].recargodeu, multa: response.data[i].multa,
                        descuento: response.data[i].mondescue, recibo: response.data[i].numreci,
                        fechapago: response.data[i].fechapago, status: response.data[i].estatus,
                        idfac: response.data[i].idfact, estatusfac: response.data[i].estatusfac, tipotransaccion: response.data[i].tipotransaccion
                    });
                }
            }
            setDeuda(deu);
            setHistorico(his);
            setActivate(false);
            setMostrar5(true);
        }).catch(function (error) {
            setTitulo("ERROR");
            setMsg(error.response.data.message)
            setActivate(false);
        })
    }

    const seleccionarRegistro = (idvehiculo) => {
        let campos = '*';
        let nomtab = 'vehiculo';
        let nomid = 'idvehiculo';
        let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idvehiculo}&nomtab=${nomtab}&nomid=${nomid}`;
        setActivate(true);
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'
            },
        }).then(function (response) {
            if (response.status == 200) {
                if (response.data.idvehiculo > 0) {
                    setVehiculo(response.data);
                    SelectDeudaVehiculo(idvehiculo);
                    seleccionarDeudaMulta(idvehiculo);
                }

            }

        }).catch(function (error) {

            setTitulo("ERROR");
            setMsg(error.response.data.message)
            setMostrar5(true)
            setActivate(false);

        })

    }

    const seleccionarDeudaMulta = (idvehiculo) => {

        let campos = '*';
        let tabla = 'multa';
        let nombreid = 'idcontribuyente';
        let nombreid2 = 'tablacontribuyente';
        let valorid2 = 'vehiculo';
        let nombreid3 = 'tipoimpuesto';
        let valorid3 = 'IMPUESTOS DE VEHICULOS';
        let endpoint = `${op.conexion}/api/consulta/modeli3string?campos=${campos}&id=${idvehiculo}&nomtab=${tabla}&nomid=${nombreid}&nomid2=${nombreid2}&id2=${valorid2}&nomid3=${nombreid3}&id3=${valorid3}`;

        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status == 200) {

                setMultas(response.data);
            }

        }).catch(function (error) {

            setTitulo("ERROR");
            setMsg(error.response.data.message)
            setMostrar(true)
            setActivate(false);

        })

    }
    const cerrarModalActualizar = () => {
        setMostrar5(false);
    }
    const consultarVehiculos = (ope, id) => (event) => {
        event.preventDefault();
        blanquear();
        if (ope === 1) {
            setMostrar5(true);
            setOperacion(1);
        } else if (ope === 4) {
            setOperacion(4);
            seleccionarRegistro(id);
        } else if (ope === 2) {
            setOperacion(2);
            seleccionarRegistro(id);
        } else if (ope === 3) {
            setOperacion(3);
            seleccionarRegistro(id);
        }
    };

    useEffect(() => {
        seleccionarRegistros();
        seleccionarFactorCambio()
    }, []);

    const cerrar = () => {
        props.menu()
    }

    return (
        <section className='col-8 m-0 p-2 border rounded'>
            <header className='col-12 m-0 px-4 py-2 d-flex justify-content-between text-light rounded-top azulGradiant'>
                <h3 className='fw-bold m-0'>
                    Estados de Cuenta de Impuestos de Vehiculos
                </h3>
                <a type='button' className='fw-bold text-light fs-6' onClick={cerrar}>
                    Salir <i className="fa fa-times ms-2"></i>
                </a>
            </header>
            <div className="col-4 m-0 my-2 p-0">
                <SearchInput className='search-input ' placeholder="Buscar" onChange={handleSearch} />
            </div>
            <div className="col-12 m-0 p-0">
                <TblContainer >
                    <TblHead />
                    <tbody>
                        {

                            records && recordsAfterPagingAndSorting().map((item, index) => (
                                <tr key={item.idvehiculo} style={{ padding: "0" }}>
                                    <td style={{ textAlign: "center", width: "40px" }}>{item.placa}</td>
                                    <td style={{ textAlign: "center", width: "40px" }}>{item.ritm}</td>
                                    <td style={{ textAlign: "left", width: "200px" }}>{item.nombrepropie}</td>
                                    <td style={{ textAlign: "center", width: "60px" }}>{item.idvehiculo}</td>
                                    <td align="center" style={{ textAlign: "center", width: "80px" }}>
                                        <button onClick={consultarVehiculos(2, item.idvehiculo)} className="btn btn-info btn-sm rounded-pill"><i className="fas fa-eye"> Consultar</i></button>
                                    </td>
                                </tr>

                            ))
                        }
                    </tbody>
                </TblContainer>
                <TblPagination />
            </div>
            <ActualizarEstadoVehiculos
                factorCambio={factorCambio}
                vehiculo={vehiculo}
                operacion={operacion}
                deuda={deuda}
                multa={multas}
                historico={historico}
                show={mostrar5}
                onHideRenderizar={seleccionarRegistros}
                onHideCancela={cerrarModalActualizar} />
            <Dimmer
                active={activate} inverted>
            </Dimmer>
        </section>
    );
}

export default TablaEstadoVehiculos;
